import { jsx } from "react/jsx-runtime";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import { validateTidalLicense } from "../../base/index.js";
function PaymentsOutlined(props) {
  return /* @__PURE__ */ jsx(
    PaymentsOutlinedIcon,
    {
      "data-testid": "PaymentsOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PaymentsOutlined",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
PaymentsOutlined.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "PaymentsOutlined"
};
validateTidalLicense();
export {
  PaymentsOutlined
};
//# sourceMappingURL=PaymentsOutlined.js.map
